// app/shared/components/GlobalLoadingIndicator.tsx

// v2

// app/shared/components/GlobalLoadingIndicator.tsx
"use client";

import React from "react";

import { useLoadingStore } from "@/app/shared/store/loadingStore";

/**
 * A simple global loading indicator that listens to the central loading store.
 */
export function GlobalLoadingIndicator() {
  const isLoading = useLoadingStore((state) => state.isLoading);

  if (!isLoading) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] flex justify-center p-4 animate-fade-in-down">
      <div className="bg-primary text-primary-foreground px-4 py-2 rounded-full flex items-center shadow-lg border">
        <div className="w-4 h-4 border-2 border-t-transparent border-current rounded-full animate-spin mr-3" />
        <span className="text-sm font-medium">Loading...</span>
      </div>
    </div>
  );
}
// v1
// // app/shared/components/GlobalLoadingIndicator.tsx
// // app/shared/components/GlobalLoadingIndicator.tsx
// 'use client';

// import { usePathname, useSearchParams } from 'next/navigation';
// import React, { useEffect, useState } from 'react';

// import { useAuthStore } from '@/app/auth/services_and_hooks/authStore';
// import { useLoadingStore } from '@/app/shared/store/loadingStore';

// export function GlobalLoadingIndicator() {
//   // Track various loading states
//   const authLoading = useAuthStore(state => state.isLoading);
//   const globalLoading = useLoadingStore(state => state.isLoading);
//   const isAnyNamedLoading = useLoadingStore(state => state.isAnyLoading());

//   // Track route changes
//   const pathname = usePathname();
//   const searchParams = useSearchParams();
//   const [isRouteChanging, setIsRouteChanging] = useState(false);
//   const [routeChangeTimeout, setRouteChangeTimeout] = useState<NodeJS.Timeout | null>(null);

//   // Detect route changes
//   useEffect(() => {
//     // Clear any existing timeout
//     if (routeChangeTimeout) {
//       clearTimeout(routeChangeTimeout);
//     }

//     // Set route changing to true
//     setIsRouteChanging(true);

//     // After a short delay, set it back to false
//     const timeout = setTimeout(() => {
//       setIsRouteChanging(false);
//     }, 500);

//     setRouteChangeTimeout(timeout);

//     return () => {
//       if (routeChangeTimeout) {
//         clearTimeout(routeChangeTimeout);
//       }
//     };
//   }, [pathname, searchParams]);

//   // Combine all loading states
//   const isLoading = authLoading || globalLoading || isAnyNamedLoading || isRouteChanging;

//   // Add a small delay before showing the loading indicator to prevent flashing
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     let timeout: NodeJS.Timeout;

//     if (isLoading) {
//       timeout = setTimeout(() => setVisible(true), 300);
//     } else {
//       setVisible(false);
//     }

//     return () => clearTimeout(timeout);
//   }, [isLoading]);

//   if (!visible) return null;

//   return (
//     <div className="fixed top-0 left-0 right-0 z-50 flex justify-center p-2">
//       <div className="bg-primary text-primary-foreground px-4 py-2 rounded-md flex items-center shadow-lg">
//         <div className="w-4 h-4 border-2 border-t-transparent border-primary-foreground rounded-full animate-spin mr-2" />
//         <span className="text-sm font-medium">Loading...</span>
//       </div>
//     </div>
//   );
// }
